import { getMfeConfig } from './services';

let mfeConfig: IMfeConfig;
let configPromise = null;
interface IMfeConfig {
    updateInterval: number;
}
export async function fetchMfeConfig(): Promise<IMfeConfig> {
    try {
        configPromise = configPromise || getMfeConfig();
        mfeConfig = (await configPromise).data;
    } catch (error) {
        mfeConfig = { updateInterval: 10 * 60 * 1000 };
    }

    return mfeConfig;
}
